<label for="{{parentId}}" class="switch" title="{{title | translate}}">
  <input id="{{parentId}}" type="checkbox" [disabled]="disabled" [(ngModel)]="value">
  <span class="slider round" (click)="onCheckChanges($event)"></span>
</label>